import React, {useEffect} from "react";
import { useLocation } from "react-router-dom";
import "./DetailPages.css";
import Title from "../../assets/tri/title.webp";
import Picture1 from "../../assets/tri/1.webp";
import Picture2 from "../../assets/tri/2.webp";
import Picture3 from "../../assets/tri/3.webp";
import Picture4 from "../../assets/tri/4.webp";
import Picture5 from "../../assets/tri/5.webp";
import Picture6 from "../../assets/tri/6.webp";
import Picture7 from "../../assets/tri/7.webp";
import Picture8 from "../../assets/tri/8.webp";
import Picture9 from "../../assets/tri/9.webp";
import Picture10 from "../../assets/tri/10.webp";
import Picture11 from "../../assets/tri/11.webp";
import Picture12 from "../../assets/tri/12.webp";
import Picture13 from "../../assets/tri/13.webp";
import Picture14 from "../../assets/tri/14.webp";
import Picture15 from "../../assets/tri/15.webp";
import Picture16 from "../../assets/tri/16.webp";
import Picture17 from "../../assets/tri/17.webp";
import Picture18 from "../../assets/tri/18.webp";
import Picture19 from "../../assets/tri/19.webp";
import Picture20 from "../../assets/tri/20.webp";
import Picture21 from "../../assets/tri/21.webp";
import Picture22 from "../../assets/tri/22.webp";
import Picture23 from "../../assets/tri/23.webp";
import Picture24 from "../../assets/tri/24.webp";
import Picture25 from "../../assets/tri/25.webp";
import Picture26 from "../../assets/tri/26.webp";
import Picture27 from "../../assets/tri/27.webp";
import Picture28 from "../../assets/tri/28.webp";
import Picture29 from "../../assets/tri/29.webp";
import Picture30 from "../../assets/tri/30.webp";
import Picture31 from "../../assets/tri/31.webp";
import Picture32 from "../../assets/tri/32.webp";
import Picture33 from "../../assets/tri/33.webp";
import Picture34 from "../../assets/tri/34.webp";
import Picture35 from "../../assets/tri/35.webp";
import Picture36 from "../../assets/tri/36.webp";
import Picture37 from "../../assets/tri/37.webp";
import Picture38 from "../../assets/tri/38.webp";
import Picture39 from "../../assets/tri/39.webp";
import Picture40 from "../../assets/tri/40.webp";
import Picture41 from "../../assets/tri/41.webp";
import Navbar from "../../components/NavBar/Navbar";
import ScrollButton from "../../components/ScrollTopButton/ScrollButton";
import ImageGalery from "../../components/ImageGalery/ImageGalery";
import Footer from "../../components/Footer/Footer";

const DetailPage = () => {
    const images = [
        { original: Picture1, thumbnail: Picture1 },
        { original: Picture2, thumbnail: Picture2 },
        { original: Picture3, thumbnail: Picture3 },
        { original: Picture4, thumbnail: Picture4 },
        { original: Picture5, thumbnail: Picture5 },
        { original: Picture6, thumbnail: Picture6 },
        { original: Picture7, thumbnail: Picture7 },
        { original: Picture8, thumbnail: Picture8 },
        { original: Picture9, thumbnail: Picture9 },
        { original: Picture10, thumbnail: Picture10 },
        { original: Picture11, thumbnail: Picture11 },
        { original: Picture12, thumbnail: Picture12 },
        { original: Picture13, thumbnail: Picture13 },
        { original: Picture14, thumbnail: Picture14 },
        { original: Picture15, thumbnail: Picture15 },
        { original: Picture16, thumbnail: Picture16 },
        { original: Picture17, thumbnail: Picture17 },
        { original: Picture18, thumbnail: Picture18 },
        { original: Picture19, thumbnail: Picture19 },
        { original: Picture20, thumbnail: Picture20 },
        { original: Picture21, thumbnail: Picture21 },
        { original: Picture22, thumbnail: Picture22 },
        { original: Picture23, thumbnail: Picture23 },
        { original: Picture24, thumbnail: Picture24 },
        { original: Picture25, thumbnail: Picture25 },
        { original: Picture26, thumbnail: Picture26 },
        { original: Picture27, thumbnail: Picture27 },
        { original: Picture28, thumbnail: Picture28 },
        { original: Picture29, thumbnail: Picture29 },
        { original: Picture30, thumbnail: Picture30 },
        { original: Picture31, thumbnail: Picture31 },
        { original: Picture32, thumbnail: Picture32 },
        { original: Picture33, thumbnail: Picture33 },
        { original: Picture34, thumbnail: Picture34 },
        { original: Picture35, thumbnail: Picture35 },
        { original: Picture36, thumbnail: Picture36 },
        { original: Picture37, thumbnail: Picture37 },
        { original: Picture38, thumbnail: Picture38 },
        { original: Picture38, thumbnail: Picture39 },
        { original: Picture40, thumbnail: Picture40 },
        { original: Picture41, thumbnail: Picture41 },

    ];

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return (
        <>
            <Navbar />
            <div className='detail-page'>
                <div className='header'>
                    <img src={Title} alt='Header' className='header-image' loading="lazy"/>
                    <h1 className='header-title'>Tři</h1>
                </div>
                <div id="info" className='info-section'>
                    <p>
                        Absurdní drama o hledání smyslu získávání titulů a způsobu jejich dosahování, získávání postavení a
                        dosahování vlivu s úžasem poznání, že úklid v tomto směru může hrát zásadní roli. Koncentrované myšlenky
                        pro pozorného diváka, který provázen humorem se bude dobírat podstaty smyslu ověnčených jmen tituly.
                        A ministerstvo v tom všem hraje důležitou úlohu. A hlavně! Je výborné umět (se) dobře uklidit.
                    </p>
                    <div className='short-info'>
                        <div className='info-item'>
                            <strong>Hrají:</strong> Docentka - Markéta Voříšková, Mladík - Adam horký, Uklízečka - Adéla
                            Pellarová
                        </div>
                        <div className='info-item'>
                            <strong>Scénář:</strong> Adéla Pellarová
                        </div>
                        <div className='info-item'>
                            <strong>Režie:</strong> Adéla Pellarová
                        </div>
                        <div className='info-item'>
                            <strong>Hudba:</strong> Šimon Martínek
                        </div>
                        <div className='info-item'>
                            <strong>Návrh scény:</strong> Adéla Pellarová
                        </div>
                        <div className='info-item'>
                            <strong>Technická realizace scény:</strong> Jakub Kopecký, Míňa Podhájecká
                        </div>
                        <div className='info-item'>
                            <strong>Výtvarná realizace scény:</strong> Amálie Popelářová, Petr Mlejnek
                        </div>
                        <div className='info-item'>
                            <strong>Kostýmy:</strong> Divadlo Di
                        </div>
                        <div className='info-item'>
                            <strong>Prostorová náročnost:</strong> Toto představení hrajeme v
                            Divadeliéru i zájezdově.
                        </div>
                        <div className='info-item'>
                            <strong>Délka trvání:</strong> 60 minut (bez přestávky)
                        </div>
                    </div>
                </div>
                <ImageGalery images={images} h2={"foto: Petra Šplíchalová"}/>
            </div>
            <ScrollButton/>
            <Footer/>
        </>
    );
};

export default DetailPage;
